import React from 'react'
import _ from 'lodash';
import { TextField } from '@mui/material';
import './TextField.scss';

const noop = () => { };

/**
 * @typedef {Object} ReactTextFieldProps
 * @property {Function=} ReactTextFieldProps.changeHandler
 * @property {number=} ReactTextFieldProps.inputLength
 * @property {string} ReactTextFieldProps.valueString
 * @property {number=} ReactTextFieldProps.wait
 */

/** @param {import('@mui/material').OutlinedTextFieldProps & ReactTextFieldProps} param0 */
const DebouncedTextField = ({
    changeHandler = noop,
    fieldClass,
    inputLength = 0,
    label,
    labelClass,
    multiline = false,
    placeholder,
    rows = 0,
    subHeader,
    subHeaderClass,
    valueString,
    value,
    wait = 300,
    ...other
}) => {
    const debouncedChangeHandler = React.useCallback(_.debounce(changeHandler, wait), []);

    return (
        <TextField
            {...other}
            label={label}
            variant="outlined"
            className={fieldClass}
            placeholder={placeholder}
            defaultValue={value}
            onChange={({ target: { value } }) => debouncedChangeHandler(valueString, value)}
            fullWidth
            multiline={multiline}
            rows={rows}
            margin="normal"
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{
                maxLength: inputLength
            }}
        />
    )
}

export default DebouncedTextField;
